// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Change_container__5upi8{
    padding-top: 10px;
}
.Change_topRow__2nD-R{
    display: flex;
    align-items: center;
    position: relative;
}
@media(max-width: 600px){
    .Change_topRow__2nD-R{
        display: block;
        height: auto;
        margin-bottom: 0;
    }
}
.Change_borderCover__Cs6Yw{
    position: absolute;
    left: -30px;
    bottom: calc(100% - 10px);
    height: 120%;
    width: 5px;
    background-color: #FFFFFF;
}
@media(max-width: 600px){
    .Change_borderCover__Cs6Yw{
        height: 50%;
    }
}
.Change_outerCircle__mrEBO{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 10px;
    left: -35px;
    height: 18px;
    width: 18px;
    background-color: #40798C;
    border-radius: 50%;
}
.Change_innerCircle__iYCZl{
    height: 8px;
    width: 8px;
    background-color: #FFFFFF;
    border-radius: 50%;
}
.Change_text__GB-Ja{
    color: #1F363D;
    font-size: 14px;
    white-space: pre-wrap;
    overflow-x: auto;
}
@media(max-width: 480px){
    .Change_text__GB-Ja{
        overflow-x: hidden;
    }
}
.Change_bold__OXM68{
    font-family: 'Gotham Medium', serif;
}
.Change_link__BcpTc{
    display: inline-block;
    color: #0182FC;
    font-style: italic;
    white-space: nowrap;
    cursor: pointer;
}
.Change_middleRow__Wj0Xu{
    display: flex;
    height: 20px;
    margin-top: 5px;
    margin-bottom: -7px;
}
.Change_datetime__1WBL7{
    color: #1F363D;
    font-size: 14px;
    opacity: 60%;
}`, "",{"version":3,"sources":["webpack://./src/components/fundraiser/Change.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI;QACI,cAAc;QACd,YAAY;QACZ,gBAAgB;IACpB;AACJ;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,yBAAyB;AAC7B;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,mCAAmC;AACvC;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,YAAY;AAChB","sourcesContent":[".container{\n    padding-top: 10px;\n}\n.topRow{\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n@media(max-width: 600px){\n    .topRow{\n        display: block;\n        height: auto;\n        margin-bottom: 0;\n    }\n}\n.borderCover{\n    position: absolute;\n    left: -30px;\n    bottom: calc(100% - 10px);\n    height: 120%;\n    width: 5px;\n    background-color: #FFFFFF;\n}\n@media(max-width: 600px){\n    .borderCover{\n        height: 50%;\n    }\n}\n.outerCircle{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 10px;\n    left: -35px;\n    height: 18px;\n    width: 18px;\n    background-color: #40798C;\n    border-radius: 50%;\n}\n.innerCircle{\n    height: 8px;\n    width: 8px;\n    background-color: #FFFFFF;\n    border-radius: 50%;\n}\n.text{\n    color: #1F363D;\n    font-size: 14px;\n    white-space: pre-wrap;\n    overflow-x: auto;\n}\n@media(max-width: 480px){\n    .text{\n        overflow-x: hidden;\n    }\n}\n.bold{\n    font-family: 'Gotham Medium', serif;\n}\n.link{\n    display: inline-block;\n    color: #0182FC;\n    font-style: italic;\n    white-space: nowrap;\n    cursor: pointer;\n}\n.middleRow{\n    display: flex;\n    height: 20px;\n    margin-top: 5px;\n    margin-bottom: -7px;\n}\n.datetime{\n    color: #1F363D;\n    font-size: 14px;\n    opacity: 60%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Change_container__5upi8`,
	"topRow": `Change_topRow__2nD-R`,
	"borderCover": `Change_borderCover__Cs6Yw`,
	"outerCircle": `Change_outerCircle__mrEBO`,
	"innerCircle": `Change_innerCircle__iYCZl`,
	"text": `Change_text__GB-Ja`,
	"bold": `Change_bold__OXM68`,
	"link": `Change_link__BcpTc`,
	"middleRow": `Change_middleRow__Wj0Xu`,
	"datetime": `Change_datetime__1WBL7`
};
export default ___CSS_LOADER_EXPORT___;
